'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconAlertTriangle = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.119 20L13.772 2.15a2 2 0 00-3.543 0L.881 20a2 2 0 001.772 2.928h18.694A2 2 0 0023.119 20zM11 8.423a1 1 0 012 0v6a1 1 0 11-2 0zm1.05 11.51h-.028a1.528 1.528 0 01-1.522-1.47 1.476 1.476 0 011.448-1.53h.028A1.527 1.527 0 0113.5 18.4a1.475 1.475 0 01-1.45 1.533z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M22.089 23.983a.903.903 0 01-.127-.008H2.03a1.065 1.065 0 01-1.18-.89 1.066 1.066 0 01.161-.758l10.091-20.18c.291-.583.722-.645.894-.645.214 0 .614.084.894.645l10.091 20.181a1.076 1.076 0 01-.269 1.454 1.064 1.064 0 01-.623.201zM1.891 22.805a.462.462 0 01-.041.067.067.067 0 00-.013.052.07.07 0 00.066.058.582.582 0 01.093-.008h20c.027 0 .054.002.081.007h.008c.02 0 .031-.004.042-.012a.069.069 0 00.016-.096.443.443 0 01-.041-.067L11.996 2.594 1.891 22.805z' }),
    _react2.default.createElement('path', { d: 'M11.996 17.479a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zM12.01 19.979a.758.758 0 01-.763-.725.756.756 0 01.207-.543.735.735 0 01.524-.231.765.765 0 01.768.726.756.756 0 01-.207.543.739.739 0 01-.524.231l-.005-.001z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 20.251c-.62 0-1.125-.505-1.125-1.125s.505-1.125 1.125-1.125 1.125.505 1.125 1.125-.505 1.125-1.125 1.125zM12 16.501a.75.75 0 01-.75-.75v-7.5a.75.75 0 011.5 0v7.5c0 .413-.337.75-.75.75z' }),
    _react2.default.createElement('path', { d: 'M2.272 24.001c-.347 0-.693-.081-1.003-.233-.543-.267-.951-.731-1.147-1.305s-.157-1.191.111-1.734L9.705 1.43A2.57 2.57 0 0110.872.263a2.527 2.527 0 011.124-.262c.984 0 1.865.547 2.298 1.429l9.473 19.298c.152.31.233.656.233 1.003 0 .607-.237 1.178-.667 1.606a2.254 2.254 0 01-1.604.664H2.272zm9.725-22.5a1.061 1.061 0 00-.945.59L1.579 21.39a.77.77 0 00.691 1.111h19.458a.768.768 0 00.773-.77.768.768 0 00-.079-.34l-9.475-19.3a1.064 1.064 0 00-.95-.59z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconAlertTriangle.displayName = 'IconAlertTriangle';
exports.default = IconAlertTriangle;